/**
 * 视频 hover 加载脚本 - 优化 GTmetrix 跑分
 * 只处理带 data-hover-load 属性的视频
 * 这些视频只在 hover 时才加载，不做任何监听或延迟处理
 */
(function() {
  'use strict';

  function loadVideo(video) {
    const src = video.dataset.videoSrc;
    if (!src || video.classList.contains('lazy-video-loaded')) return;

    // 创建 source 元素
    const source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';

    // 添加到视频元素
    video.appendChild(source);

    // 加载视频（如果有 autoplay 属性会自动播放）
    video.load();

    // 清理数据属性
    delete video.dataset.videoSrc;
    video.classList.remove('lazy-video');
    video.classList.add('lazy-video-loaded');
  }

  function initHoverLoadVideos() {
    // 只处理带 data-hover-load 属性的视频
    const hoverVideos = document.querySelectorAll('video.lazy-video[data-hover-load]');
    
    hoverVideos.forEach(function(video) {
      // 找到父级产品卡片
      const card = video.closest('.card--product-newrelease, .card--product');
      if (!card) return;

      let loaded = false;
      
      // 在卡片 hover 时加载视频
      card.addEventListener('mouseenter', function() {
        if (!loaded && video.dataset.videoSrc) {
          loadVideo(video);
          loaded = true;
        }
      }, { once: true });
    });
  }

  // 初始化：立即执行，不需要延迟
  if (document.readyState === 'complete') {
    initHoverLoadVideos();
  } else {
    window.addEventListener('load', initHoverLoadVideos);
  }

  // Shopify Section 动态加载支持
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initHoverLoadVideos);
  }
})();
